import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { buildApiUrl, API_ENDPOINTS } from "./config/api";

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        // El token viaja en la cookie HttpOnly; credentials:"include" la envía automáticamente
        const response = await fetch(buildApiUrl(API_ENDPOINTS.current), {
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });

        if (response.ok) {
          const data = await response.json();
          const type = data?.datosUsuario?.type;
          if (type) localStorage.setItem("userType", type);
          setIsAuthenticated(true);
        } else if (response.status === 401 || response.status === 403) {
          localStorage.removeItem("userType");
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(false);
        }
      } catch {
        setIsAuthenticated(false);
      }
    };

    checkAuthentication();
  }, []);

  if (isAuthenticated === null) {
    return <div>Verificando autenticación...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
